import { StyleSheet } from "react-native";

export default StyleSheet.create({
    image: {
        // resizeMode: "contain",
        marginHorizontal: -4,
    },
});
